import type { CoverPageData } from '@core/presentationPrint';

interface CoverPageProps {
  data: CoverPageData;
}

export function CoverPage({ data }: CoverPageProps) {
  return (
    <div className="dp-page dp-cover-page">
      <header className="dp-cover-header">
        <h1>{data.title}</h1>
      </header>

      {/* Indicative guidance statement */}
      <div className="dp-indicative-notice" style={{
        padding: '12px 16px',
        marginBottom: '16px',
        background: '#f0f9ff',
        borderLeft: '4px solid #2563eb',
        borderRadius: '0 8px 8px 0',
        fontSize: '13px',
        color: '#1e40af',
        lineHeight: 1.5
      }}>
        This report provides indicative guidance based on the information provided.
        Final recommendations follow an in-home survey.
      </div>

      <div className="dp-cover-body">
        <p className="dp-opening-paragraph">{data.openingParagraph}</p>

        <p className="dp-occupancy-line">
          <strong>{data.occupancyLine}</strong>
        </p>

        {/* How you use your home - lifestyle preferences */}
        {data.lifestyleSummary && data.lifestyleSummary.items.length > 0 && (
          <div className="dp-lifestyle-summary" style={{
            marginTop: '16px',
            padding: '12px 16px',
            background: '#f8fafc',
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
          }}>
            <h3 style={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#1e293b',
              marginBottom: '8px'
            }}>
              How you use your home
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '6px'
            }}>
              {data.lifestyleSummary.items.map((item, idx) => (
                <li key={idx} style={{
                  fontSize: '12px',
                  color: '#475569',
                  display: 'flex',
                  gap: '4px'
                }}>
                  <span style={{ fontWeight: 500, color: '#64748b' }}>{item.label}:</span>
                  <span>{item.value}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {data.assumptionsLine && (
          <p className="dp-assumptions-line">{data.assumptionsLine}</p>
        )}
      </div>

      <footer className="dp-cover-footer">
        <p className="dp-generated-date">Generated: {data.generatedDate}</p>
        <p className="dp-copyright" style={{
          fontSize: '11px',
          color: '#64748b',
          marginTop: '8px'
        }}>
          © 2024–{new Date().getFullYear()} Atlas PHM. Independently developed software.
        </p>
      </footer>
    </div>
  );
}
